import Vue from 'vue';
import VueRouter from 'vue-router';
import Question from '../views/Question.vue';
import Client from '../views/Client.vue';
import Form from '../views/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/admin',
    name: 'Client',
    component: Client,
  },
  {
    path: '/admin/question',
    name: 'Question',
    component: Question,
  },
  {
    path: '/admin/question/:clientId',
    name: 'AdminForm',
    component: Form,
  },
  {
    path: '/:clientId',
    name: 'Form',
    component: Form,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
